import React from 'react';

import VehicleImage from 'components/VehicleImage';
import { FormatInteger } from 'utils/format';
import { Flexer, Spacer, Icon } from '@ontruck/orc';
import { palletsByCountry } from 'utils/journey';
import { StyledNoWrap, StyledSeparator } from 'modules/assignment-cards/styled';

const t = {
  kg: 'kg',
  american: 'Us',
  european: 'Eu',
  meters: 'm',
};

const VehicleInfo = ({ model }) => {
  if (!model) {
    return null;
  }

  const { carrier, vehicle } = model;

  if (!vehicle) {
    return null;
  }

  const {
    has_superior_loading,
    has_lateral_loading,
    has_liftgate,
    max_pallets,
    max_weight,
    container_height,
  } = vehicle;

  const { country } = carrier || {};

  const pallet_type = palletsByCountry[country] || palletsByCountry.default;

  const pallets = max_pallets ? `${max_pallets} ${t[pallet_type]}` : null;

  return (
    <>
      <StyledSeparator mLeft="S" pRight="S">
        <VehicleImage type={vehicle.vehicle_type} size="2.5rem" color="grey700" />
      </StyledSeparator>
      <Spacer mLeft="S" data-testid="pallets">
        {pallets}
      </Spacer>
      <Spacer mLeft="S" data-testid="weight">
        <StyledNoWrap>
          <FormatInteger value={max_weight} /> {t.kg}
        </StyledNoWrap>
      </Spacer>
      <Spacer mLeft="S" data-testid="height">
        <StyledNoWrap>
          {container_height} {t.meters}
        </StyledNoWrap>
      </Spacer>
      {(has_liftgate || has_lateral_loading || has_superior_loading) && (
        <Flexer.Parent mLeft="S">
          {has_liftgate && (
            <Spacer mRight="XS" data-testid="lifgate">
              <Icon glyph="extras-liftgate" size="2.4rem" color="grey500" />
            </Spacer>
          )}
          {has_lateral_loading && (
            <Spacer mRight="XS" data-testid="lateral_loading">
              <Icon glyph="extras-sideload" size="2.4rem" color="grey500" />
            </Spacer>
          )}
          {has_superior_loading && (
            <Spacer mRight="XS" data-testid="superior_loading">
              <Icon glyph="extras-retractableroof" size="2.4rem" color="grey500" />
            </Spacer>
          )}
        </Flexer.Parent>
      )}
    </>
  );
};

export default VehicleInfo;
